import { __ } from "@libs/utilities"
import { IRating } from "@/modules/pe-fest-module/data/interfaces"
import Shortcode from "src/libs/useful/shortcode"

/* Protopia Ecosystem component */
export interface ICriteryDescriptionsProps {
    ratings: IRating[]
}
const CriteryDescriptions = ({ratings}: ICriteryDescriptionsProps): JSX.Element => {
    return <div className='pe-critery-descriptions-container' data-testid="critery-description">
        {
            !!ratings.filter(r => r.description).length 
                && 
                <div className="my-2 lead">{__("Experts's descriptions")}:</div>
        }
        {
            ratings.map(r => <CriterySingleRating rating={r} key={r.id} />)
        }
    </div>
}
export default CriteryDescriptions


/* Protopia Ecosystem component */
interface ICriterySingleDescriptionsProps {
   rating: IRating
}
const CriterySingleRating = (props: ICriterySingleDescriptionsProps): JSX.Element => {
    return props.rating?.description 
        ?
        <div className='pe-critery-single-descriptions-container small' data-testid="critery-description-single">
            <div className="title mt-1" >
                    {props.rating?.display_name + ` | ${props.rating?.rating}`}
            </div>
            <Shortcode content={ props.rating?.description } />
        </div>
        : 
        <></>
} 